'use strict';

/* globals config, $ */

require([
	config.relative_path + '/plugins/nodebb-plugin-ideas-board/static/vendor/vue.js',
	'translator'], function (Vue, translator) {
	var internals = {};

	Vue.component('text-note', {
		props: ['note', 'saveNote', 'editMode'],
		data: function () {
			return {
				noteId: this.note.noteId,
				content: this.note.content,
				clickToWrite: '',
			};
		},
		watch: {
			editMode: function (editMode) {
				if (editMode) {
					internals.initAutoSize();
				}
			},
		},
		mounted: function () {
			var _this = this;

			internals.getTranslation('click-to-write', function (clickToWrite) {
				_this.clickToWrite = clickToWrite;
			});
		},
		methods: {

		},
		template: '<div class="note-text">' +
		'<textarea v-if="editMode" class="autoExpand" rows="1" v-model="content.text" placeholder="Note content here..." v-on:blur="saveNote()"></textarea>' +
		'<span v-if="!editMode">{{content.text || clickToWrite}}</span>' +
		'</div>',
	});

	internals.initAutoSize = function () {
		$.autoExpand();
	};

	internals.getTranslation = function (toTranslate, callback) {
		translator.translate('[[ideas-board:' + toTranslate + ']]', callback);
	};
});
